import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../utils/api";
import styles from "./ViewRolePage.module.scss";
import { AxiosResponse, AxiosErrorType } from "../../../src/types";

interface AppAccessLevel {
  id: number;
  name: string;
  permissions: Record<string, boolean>;
}

const ViewAppAccessLevelPage: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [accessLevel, setAccessLevel] = useState<AppAccessLevel | null>(null);
  const [error, setError] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.post<AxiosResponse<{ access_levels: AppAccessLevel[] }>>("/core/role/access-level/get", {});
        const accessLevelData = response.data.access_levels?.find((al) => al.id === parseInt(id || "0"));
        if (!accessLevelData) {
          throw new Error("App access level not found");
        }
        setAccessLevel(accessLevelData);
      } catch (err: any) {
        setError(err.response?.data?.message || "Failed to fetch app access level");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error || !accessLevel) {
    return <div className={styles.error}>{error || "App access level not found"}</div>;
  }

  return (
    <div className={styles.container}>
      <h2>View App Access Level</h2>
      <div className={styles.formGroup}>
        <label>Access Level Name</label>
        <p>{accessLevel.name}</p>
      </div>
      <div className={styles.formGroup}>
        <label>Permissions</label>
        <p>{JSON.stringify(accessLevel.permissions)}</p>
      </div>
      <button onClick={() => navigate("/roles")}>Back to Roles</button>
    </div>
  );
};

export default ViewAppAccessLevelPage;
